<template>
    <el-input 
        class="galaxy-num-input" 
        v-model="displayValue" 
        :size="size"
        :clearable="clearable"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="changeInput"
        @blur="onBlur"
        @focus="focus">
    </el-input>
</template>
<script>
export default {
    props:{
        value:{
            type:[Number,String],
            default:""
        },
        min:{
            type:Number,
            default:-999999999999999
        },

        max:{
            type:Number,
            default:999999999999999
        },
        precision:{
            type:Number,
            default:2
        },
        size:{
            type:String,
            default:"",
        },
        disabled:{
            type:Boolean,
            default:false
        },
        clearable:{
            type:Boolean,
            default:true
        },
        placeholder: {
            type:String,
            default:"",
        }
    },

    data(){
        return {
           displayValue:"", 
        }
    },

    watch:{
        value(){
            this.displayValue = this.format(this.value);
        },

        displayValue(){
            
        }
    },

    mounted(){
        this.displayValue = this.format(this.value);
    },

    methods:{

        format (val) {
            if(this.checkRates(val)){
                return Number(this.th2Num(val)).toFixed(this.precision).replace(/\B(?=(\d{3})+(?!\d))/g,',');
            }else{
                return "";
            }
        },

        checkRates(str){
            if(str===null||str===undefined){
                return false
            }else{
                let numStr = str.toString().trim().replace(/,/g, "",)
                var re = /^([0-9]+\.?[0-9]*|-[0-9]+\.?[0-9]*)$/;
                return re.test(numStr);
            }
        },

        th2Num(str){
            if(str===null||str===undefined||str===""){
                return 0;
            }else{
                return Number(str.toString().trim().replace(/,/g, "",));
            }
        },

        onBlur(){
            this.changeInput(this.displayValue);
        },


        changeInput(val){
            const {min,max} = this.$props;
            let num = Number(val.trim().replace(/,/g, ""));
            if(!this.checkRates(val)){
                this.displayValue = "";
            }else{
                if(num<min){
                    num = min;
                }
                if(num>max){
                    num = max;
                }
            }
            this.displayValue = this.format(num);
            this.$emit("input",Number(num.toFixed(this.precision)));
            this.$emit("change",Number(num.toFixed(this.precision)));
        },

        focus(){
            this.$emit("focus");
        },

    },
}
</script>
<style lang="css" scoped>
.galaxy-num-input /deep/ .el-input__inner{
        text-align: center !important;
}
</style>
